import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["receiverSelect",
        "typeInput",
        "memberSelectVisibility",
        "memberSelectWrapper",
        "memberSelectContent",
        "memberSelect",
        "memberSelectedItem",
        "payerDetails",
    ]

    static values = {
        allText: String,
        emptyGroupText: String
    }

    connect() {
        if (this.hasReceiverSelectTarget) {
            this.updateReceiverType()
        }
        this.setupEventListeners()
    }

    setupEventListeners() {
        this.memberSelectWrapperTarget.querySelector('.ts-control').addEventListener('click', (e) => this.toggleDropdown(e));
        document.addEventListener('click', (e) => this.closeDropdownOutside(e));
    }

    updateReceiverType() {
        const selectedOption = this.receiverSelectTarget.options[this.receiverSelectTarget.selectedIndex]
        if (selectedOption) {
            this.typeInputTarget.value = selectedOption.dataset.type

            if (selectedOption.dataset.type === 'group') {
                this.memberSelectVisibilityTarget.style.display = ''
                try {
                    const groupData = JSON.parse(selectedOption.value);
                    this.populateMemberSelect(groupData);
                } catch (error) {
                    console.error('Error parsing group data:', error);
                }
            } else {
                this.memberSelectVisibilityTarget.style.display = 'none'
            }
        } else {
            console.warn('No option selected');
        }
    }

    populateMemberSelect(groupData) {
        this.memberSelectContentTarget.innerHTML = '';
        this.memberSelectTarget.innerHTML = '';

        if (groupData && groupData.clients && groupData.clients.length > 0) {
            this.addOption('all', this.allTextValue);
            groupData.clients.forEach(client => {
                const clientData = {
                    clientId: client.clientId,
                    clientContractID: client.clientContractID
                };
                this.addOption(
                    JSON.stringify(clientData),
                    `${client.clientName} ${client.clientSurname}`
                );
            });
            this.typeInputTarget.value = 'group';
        } else {
            this.addOption('empty', this.emptyGroupTextValue);
            this.typeInputTarget.value = 'group';
        }

        this.selectOption(this.memberSelectTarget.options[0]);
    }

    addOption(value, text) {
        const template = document.getElementById('option-template');
        if (!template) {
            console.error('Option template not found');
            return;
        }

        const option = template.content.cloneNode(true).firstElementChild;
        option.setAttribute('data-value', value);
        option.querySelector('.option-text').textContent = text;

        this.memberSelectContentTarget.appendChild(option);

        const selectOption = document.createElement('option');
        selectOption.value = value;
        selectOption.textContent = text;
        this.memberSelectTarget.appendChild(selectOption);

        option.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectOption(selectOption);
        });
    }

    async selectOption(option) {
        this.memberSelectTarget.value = option.value;
        this.memberSelectedItemTarget.textContent = option.textContent;
        this.closeDropdown();
        this.memberSelectWrapperTarget.querySelector('.ts-control').classList.add('has-items');

        if (option.value === 'all') {
            this.typeInputTarget.value = 'group';
            this.payerDetailsTarget.innerHTML = '';
        } else if (option.value !== 'empty') {
            this.typeInputTarget.value = 'member';
            try {
                const clientData = JSON.parse(option.value);
                await this.fetchPayerDetails(clientData.clientId, clientData.clientContractID);
            } catch (error) {
            }
        }
    }

    toggleDropdown(event) {
        event.stopPropagation();
        const dropdown = this.memberSelectWrapperTarget.querySelector('.ts-dropdown');
        dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
    }

    closeDropdown() {
        this.memberSelectWrapperTarget.querySelector('.ts-dropdown').style.display = 'none'
    }

    closeDropdownOutside(event) {
        if (!this.memberSelectWrapperTarget.contains(event.target)) {
            this.closeDropdown()
        }
    }

    async fetchPayerDetails(memberId, contractId) {
        this.payerDetailsTarget.classList.add('is-loading-link');
        try {
            const response = await fetch(`/wp-json/api/dashboard/messages/actions/get-payer-details?member_id=${memberId}&contract_id=${contractId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseText = await response.text();

            let data;
            try {
                const jsonStart = responseText.indexOf('{');
                const jsonEnd = responseText.lastIndexOf('}');

                if (jsonStart >= 0 && jsonEnd >= 0) {
                    const jsonString = responseText.substring(jsonStart, jsonEnd + 1);
                    data = JSON.parse(jsonString);
                } else {
                    throw new Error('No valid JSON found in response');
                }
            } catch (parseError) {
                throw parseError;
            }

            this.payerDetailsTarget.classList.remove('is-loading-link');
            this.displayPayerDetails(data);
        } catch (error) {
            console.error('Error fetching payer details:', error);
            this.payerDetailsTarget.classList.remove('is-loading-link');
            this.payerDetailsTarget.innerHTML = '';
        }
    }

    displayPayerDetails(data) {
        if (!data) {
            this.payerDetailsTarget.innerHTML = '';
            return;
        }

        const details = [
            data.payerName + ' ' + data.payerSurname,
            data.payerEmail,
            data.payerPhone
        ].filter(Boolean).join(', ');

        this.payerDetailsTarget.innerHTML = `
            <span>
                ${details}
            </span>
        `;
    }
}
